export default function GetDateFromMMDDYYYY(date) {
    if (date) {
        let currentDate;
        const year = date.substring(6, 10);
        const month = date.substring(0, 2);
        const day = date.substring(3, 5);
        currentDate = year + "-" + month + "-" + day;
        return currentDate;
    }
}